import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./Loader.module.css";

const LoaderSpinner = ({ sizeClass, colorClass, text }) => (
  <div className={`${styles.loader} ${sizeClass} ${colorClass}`}>
    <div className={styles.loaderRing}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    {text && <div className={styles.loaderText}>{text}</div>}
  </div>
);

LoaderSpinner.propTypes = {
  sizeClass: PropTypes.string.isRequired,
  colorClass: PropTypes.string.isRequired,
  text: PropTypes.string,
};

const Loader = ({
  size = "medium",
  color = "primary",
  overlay = false,
  text = "",
  fullScreen = false,
  scrollToTop = false,
}) => {
  // Scroll to top when loader is shown (if enabled)
  useEffect(() => {
    if (scrollToTop || fullScreen) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [scrollToTop, fullScreen]);

  const sizeClass =
    styles[`loader${size.charAt(0).toUpperCase() + size.slice(1)}`];
  const colorClass =
    styles[`loader${color.charAt(0).toUpperCase() + color.slice(1)}`];

  if (fullScreen) {
    return (
      <div className={styles.fullScreenLoader}>
        <LoaderSpinner sizeClass={sizeClass} colorClass={colorClass} text={text} />
      </div>
    );
  }

  if (overlay) {
    return (
      <div className={styles.loaderOverlay}>
        <LoaderSpinner sizeClass={sizeClass} colorClass={colorClass} text={text} />
      </div>
    );
  }

  return <LoaderSpinner sizeClass={sizeClass} colorClass={colorClass} text={text} />;
};

export default Loader;

Loader.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  overlay: PropTypes.bool,
  text: PropTypes.string,
  fullScreen: PropTypes.bool,
  scrollToTop: PropTypes.bool,
};
